import React from 'react';
import { useSeasonOptions } from '../../hooks/useSeasonOptions';
import { Loader2 } from 'lucide-react';

interface SeasonFilterProps {
  selectedSeason: string | null;
  onSeasonChange: (season: string | null) => void;
}

export default function SeasonFilter({ selectedSeason, onSeasonChange }: SeasonFilterProps) {
  const { options, loading, error } = useSeasonOptions();

  if (error) {
    return (
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Filter by Season
        </label>
        <p className="text-sm text-red-600">Failed to load season options</p>
      </div>
    );
  }

  return (
    <div className="mb-6">
      <label htmlFor="season" className="block text-sm font-medium text-gray-700 mb-2">
        Filter by Season
      </label>
      <div className="relative">
        <select
          id="season"
          value={selectedSeason || ''}
          onChange={(e) => onSeasonChange(e.target.value || null)}
          disabled={loading}
          className="w-full max-w-xs rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
        >
          <option value="">All Seasons</option>
          {options.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        {loading && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2">
            <Loader2 className="h-4 w-4 animate-spin text-gray-400" />
          </div>
        )}
      </div>
    </div>
  );
}